import { Routes } from '@angular/router';
import { CanActivateViaAuthGuard } from './services/guards/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'my-ucrop-home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    data: {
      title: 'login',
    },
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'reset-password',
    data: {
      title: 'auth_forgotten_password_login',
    },
    loadComponent: () =>
      import('./auth/password-reset/password-reset.component').then(
        (m) => m.PasswordResetComponent
      ),
  },
  {
    path: 'my-ucrop-home',
    data: {
      title: 'myucrop',
    },
    loadComponent: () => import('./home/home/home.page').then((m) => m.HomePage),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'administrative-management',
    data: {
      title: 'menu_subscriptions',
    },
    loadComponent: () =>
      import(
        './administrative-management/administrative-management/administrative-management-page.component'
      ).then((m) => m.AdministrativeManagementPageComponent),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'admin-panel',
    data: {
      title: 'menu_admin_panel',
    },
    loadComponent: () =>
      import('./admin-panel/admin-panel/admin-panel.page').then(
        (m) => m.AdminPanelPage
      ),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'plans',
    data: {
      title: 'menu_plans',
    },
    loadComponent: () => import('./plans/plans/plans.page').then((m) => m.PlansPage),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'billing-addresses',
    data: {
      title: 'billing_addresses',
    },
    loadComponent: () =>
      import('./billing/billing-addresses/billing-addresses.page').then(
        (m) => m.BillingAddressesPage
      ),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'modules',
    data: {
      title: 'modules_header',
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/modules-screen/modules-screen.page').then(
            (m) => m.ModulesScreenPage
          ),
        canActivate: [CanActivateViaAuthGuard],
      },
      {
        path: 'irrigation_consulting',
        loadComponent: () =>
          import('./modules/irrigation-consulting/irrigation-consulting.page').then(
            (m) => m.IrrigationConsultingPage
          ),
        canActivate: [CanActivateViaAuthGuard],
      },
      {
        path: 'sensors_360',
        loadComponent: () =>
          import('./modules/ntc360/ntc360.component').then(
            (m) => m.Ntc360Component
          ),
        canActivate: [CanActivateViaAuthGuard],
      },
    ],
  },
  {
    path: 'subscriptions',
    data: {
      title: 'menu_subscriptions',
    },
    children: [
      {
        path: 'simulator',
        loadComponent: () =>
          import(
            './subscriptions/subscriptions-simulator/subscriptions-simulator.component'
          ).then((m) => m.SubscriptionsSimulatorComponent),
        canActivate: [CanActivateViaAuthGuard],
      },
      {
        path: 'create',
        loadComponent: () =>
          import(
            './subscriptions/subscriptions-creation/subscriptions-creation.component'
          ).then((m) => m.SubscriptionsCreationComponent),
        canActivate: [CanActivateViaAuthGuard],
      },
      {
        path: 'attach/:vid',
        loadComponent: () =>
          import(
            './subscriptions/subscriptions-creation/subscriptions-creation.component'
          ).then((m) => m.SubscriptionsCreationComponent),
        canActivate: [CanActivateViaAuthGuard],
      },
      {
        path: ':vid',
        loadComponent: () =>
          import(
            './subscriptions/subscriptions-edit/subscriptions-edit.component'
          ).then((m) => m.SubscriptionsEditComponent),
        canActivate: [CanActivateViaAuthGuard],
      },
    ],
  },
  {
    path: 'payment-methods',
    data: {
      title: 'profile_payment_methods',
    },
    loadComponent: () =>
      import('./payments/payment-methods/payment-methods.page').then(
        (m) => m.PaymentMethodsPage
      ),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: 'profile',
    data: {
      title: 'profile_profile',
    },
    loadComponent: () =>
      import('./profile/profile-screen/profile-screen.page').then(
        (m) => m.ProfileScreenPage
      ),
    canActivate: [CanActivateViaAuthGuard],
  },
  {
    path: '**',
    redirectTo: 'my-ucrop-home',
  },
];
